import { base64ToStr } from '@/utils/util';
import { gpt35Icon, planIcon, dalleIcon, fanchuanIcon, omniIcon, wenXinIcon } from '@/svg';

export const chatGPT = base64ToStr('Q2hhdEdQVA==');
export const gpt35 = base64ToStr('R1BULTMuNQ==');
export const gpt40 = base64ToStr('R1BULTQuMA==');
export const omni = base64ToStr('R1BULTRv');
export const dalle3 = base64ToStr('REFMTMK3RS0z');
export const mj = base64ToStr('TWlkam91cm55');
export const wenXin = '文心一言 3.5';
export const openai = base64ToStr('T3BlbkFJ');
export const ai = base64ToStr('QUk=');
export const modelTypes = [
	// 3.5
	{
		type: 0,
		title: gpt35,
		des: base64ToStr('6Z2e5bi46YCC5ZCI5pel5bi45Lu75Yqh'),
		firstTitle: chatGPT,
		subTile: base64ToStr('My41'),
		switchIcon: gpt35Icon
	},
];